<script setup>
/**
 * FormControlModulestructureDefaultValue
 * Dynamic polymorphism form-control factory wrapper.
 * Inspects structural configuration types on mount to assign custom layout labels,
 * safely hiding itself if a structure style falls outside valid default profiles.
 */
import {onMounted} from 'vue'
import FormControlTypeCheckbox from '@/common/form-control-type/FormControlTypeCheckbox.vue'
import FormControlTypeCurrency from '@/common/form-control-type/FormControlTypeCurrency.vue'
import FormControlTypeText from '@/common/form-control-type/FormControlTypeText.vue'
import FormControlTypeTextarea from '@/common/form-control-type/FormControlTypeTextarea.vue'
import FormControlTypeNumber from '@/common/form-control-type/FormControlTypeNumber.vue'

import {useId} from '@/utils/useId'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

const autoId = useId()

onMounted(() => {
    if (!props.field || !props.currentData) return

    switch (props.currentData.type) {
        case 'currency':
        case 'hidden':
        case 'number':
        case 'text':
        case 'textarea':
            break

        case 'date':
            props.field.label = 'Default to current time'
            break

        case 'select':
            props.field.label = 'Default option'
            break

        case 'texteditor':
            if (!props.field.id) {
                props.field.id = `editor-${autoId}`
            }
            break

        default:
            props.field.hidden = true
            break
    }
})
</script>

<template>
    <div class="form-control-structure-default-value-wrapper">

        <FormControlTypeCurrency
            v-if="currentData.type === 'currency'"
            :current-data="currentData"
            :field="field"
            :form-id="formId"
        />

        <FormControlTypeCheckbox
            v-else-if="currentData.type === 'date'"
            :current-data="currentData"
            :field="field"
            :form-id="formId"
        />

        <FormControlTypeNumber
            v-else-if="currentData.type === 'number'"
            :current-data="currentData"
            :field="field"
            :form-id="formId"
        />

        <FormControlTypeText
            v-else-if="currentData.type === 'select'"
            :current-data="currentData"
            :field="field"
            :form-id="formId"
        />

        <FormControlTypeText
            v-else-if="currentData.type === 'text'"
            :current-data="currentData"
            :field="field"
            :form-id="formId"
        />

        <FormControlTypeTextarea
            v-else-if="currentData.type === 'textarea'"
            :current-data="currentData"
            :field="field"
            :form-id="formId"
        />

        <FormControlTypeTextarea
            v-else-if="currentData.type === 'texteditor'"
            :current-data="currentData"
            :field="field"
            :form-id="formId"
        />

    </div>
</template>